import React, { useState } from 'react';
import { FaLanguage } from 'react-icons/fa';
import logo from '../../assets/finance7.png';
import Translator from './Essentials/Translator';

const Header = ({ onSidebarToggle }) => {
  const [showTranslator, setShowTranslator] = useState(false);

  const toggleTranslator = () => setShowTranslator(!showTranslator);

  return (
    <>
      <header className="fixed top-0 left-0 w-full bg-[#000300] shadow-md p-2 flex justify-between items-center z-50">
        {/* Mobile Menu Button */}
        <div className='pt-3'> 
        <button 
          onClick={onSidebarToggle} 
          className="text-white text-2xl focus:outline-none md:hidden px-2  hover:text-gray-300 transition-colors"
          aria-label="Toggle menu"
        >
          &#9776;
        </button>
        </div>
        
        {/* Logo - Center aligned on mobile, left-aligned on md and up */}
        <div className="flex-1 flex justify-center sm:justify-center md:justify-start ml-11 sm:ml-14 md:ml-0.5 lg:ml-0">
          <img 
            src={logo} 
            alt="Company Logo" 
            className="h-7 xs:h-9 sm:h-10 md:h-11 object-contain md:ml-2"
            style={{
              width: 'auto',
              maxWidth: '200px',
              minWidth: '140px'
            }}
          />
        </div>
        
        {/* Language Change Button - Matches Navbar Behavior */}
        <div className="flex items-center pt-1">
          {/* Desktop Version (md and up) */}
          <button 
            onClick={toggleTranslator}
            className="hidden md:flex items-center gap-1 lg:gap-2 text-white hover:text-gray-400 transition-colors font-semibold text-sm lg:text-base whitespace-nowrap"
            aria-label="Change language"
          >
            <FaLanguage className="text-base lg:text-lg" />
            <span>Change Language</span>
          </button>
          
          {/* Mobile Version (below md) */}
          <button 
            onClick={toggleTranslator}
            className="md:hidden flex items-center gap-1  text-white font-medium text-xs sm:text-sm border border-gray-600 px-2 py-1 rounded-md hover:bg-gray-800 transition-all whitespace-nowrap"
            aria-label="Change language"
          >
            <FaLanguage className="text-base" />
            <span>Language</span>
          </button>
        </div>
      </header>

      {/* Translator Card Popup */}
      <Translator show={showTranslator} onClose={toggleTranslator} />
    </>
  );
};

export default Header;